import { Text } from '@ksyos/design-system';
import { styled } from 'styled-components';

export const Step = styled(Text)`
    color: #ff37f0;
    font-size: 16px;
    margin-bottom: 8px;
`;
